import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { Box, Typography } from "@material-ui/core";
import DefaultQuestions from "./DefaultQuestions";
import CustomQuestions from "./CustomQuestions";

const OnBoardingQuestions = () => {
  const { t } = useTranslation();
  const {
    // register,
    watch,
    // setValue,
    // formState: { errors },
  } = useFormContext();
  const { companySetting } = watch();
  return (
    <Fragment>
      <Typography variant="subtitle2" className="font-semibold font-16">
        Onboarding &amp; profile questions
      </Typography>
      <Box mt={1} width="100%">
        <DefaultQuestions />
      </Box>
      {companySetting ? (
        <Box mt={1} width="100%">
          <CustomQuestions />
        </Box>
      ) : null}
    </Fragment>
  );
};

export default OnBoardingQuestions;
